import React, { useState } from 'react';
import './ExpertCard.scss';
import { BsBookmark } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";

export default function ExpertCard({ data, onEdit }) {
  const [showMobileDetails, setShowMobileDetails] = useState(false);

  const min = data.risk;
  const max = data.resistanceHigh;
  const cmpPercent = ((data.cmp - min) / (max - min)) * 100;

  return (
    <div className="expert-card">
      <div className="card-top">
        {/* LEFT */}
        <div className="section section-left">

          {/* WRAP FOR FLEX */}
          <div className="mobile-header">

            <div className="coin-wrap">
              <div className="coin-icon">{data.symbol}</div>
              <div>
                <div className="coin-title">
                  {data.coin} <span className="info-icon">ⓘ</span>
                </div>

                <div className="price-row">
                  ${data.price}
                  <span className="positive">
                    +{data.change} ({data.percent}%)
                  </span>
                </div>

                <div className="date">{data.date}</div>
              </div>
            </div>

            {/* MOBILE ACTIONS */}
            <div className="mobile-actions">
              <button className="exit-btn">Exit</button>

              <div className="edit-icon" onClick={() => onEdit(data.id)}>
                <FiEdit />
              </div>
            </div>

          </div>

          {/* BELOW COIN WRAP */}
          <div className="mobile-bottom">
            <div className="mobile-status">
              Status : <span className="status-active">Active Now</span>
            </div>

           <div className="mobile-gap">
            <div className="gap-label">Gap to Level</div>
            <span className="gap-value">{data.gap}%</span>
           </div>
          </div>

        </div>

        <div className="divider" />

        {/* MIDDLE */}
        <div className="section section-middle">
          <div className="zones-row">
            <div className="zone-item">
              <div className="zone-title">Risk area</div>
              <div className="zone-value risk">${data.risk}</div>
            </div>

            <div className="zone-divider" />

            <div className="zone-item">
              <div className="zone-title">Support Zone</div>
              <div className="zone-value support">
                ${data.supportLow} | ${data.supportHigh}
              </div>
            </div>

            <div className="zone-divider" />

            <div className="zone-item">
              <div className="zone-title">Resistance Zone</div>
              <div className="zone-value resistance">
                ${data.resistanceLow} | ${data.resistanceHigh}
              </div>
            </div>
          </div>

          <div className="middle-bottom">
            <div className="gap-row">
              Gap to Level <span>{data.gap}%</span>
            </div>
          </div>
        </div>

        <div className="divider" />

        {/* RIGHT */}
        <div className="section section-right">
          <div className="top-actions">
            <button className="exit-btn">Exit</button>

            <div className="edit-icon" onClick={() => onEdit(data.id)}>
              <FiEdit />
            </div>
          </div>

          <div className="cmp-head">CMP</div>
          <div className="cmp-price">${data.cmp}</div>

          <div className="cmp-bar">
            <span className="pill risk">Risk area</span>
            <span className="pill support">Support Zone</span>
            <span className="pill resistance">Resistance Zone</span>

            <div className="cmp-pointer" style={{ left: `${cmpPercent}%` }}>
              ▼
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE VIEW DETAILS */}
      <div
        className="view-details mobile-only"
        onClick={() =>
          setShowMobileDetails(showMobileDetails === data.id ? null : data.id)
        }
      >
        <div className="view-left">
          <img src="https://i.pravatar.cc/32" alt="profile" className="profile-pic" />
          <span className="mobile-date">{data.date}</span>
        </div>

        <div className="view-right">
          View Details
          <span className={`arrow ${showMobileDetails === data.id ? 'up' : ''}`}>
            ▾
          </span>
        </div>
      </div>

      {showMobileDetails === data.id && (
        <div className="mobile-details">
          <div className="zones-row">
            <div className="zone-item">
              <div className="zone-title">Risk area</div>
              <div className="zone-value risk">${data.risk}</div>
            </div>

            <div className="zone-item">
              <div className="zone-title">Support Zone</div>
              <div className="zone-value support">
                ${data.supportLow} | ${data.supportHigh}
              </div>
            </div>

            <div className="zone-item">
              <div className="zone-title">Resistance Zone</div>
              <div className="zone-value resistance">
                ${data.resistanceLow} | ${data.resistanceHigh}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <div className="card-footer single-line-footer">
        <div className="footer-left">
          <div className="footer-ticker">
            <span className="green-dot" />
            <span className="footer-text-item">Level 1 Reached at 3.36% on Aug 22, 2024, 03:10 PM ITS</span>

            <span className="green-dot small" />

            <span className="footer-text-item">Level 2 Reached at 5.89% on Aug 24, 2024, 11:45 AM ITS</span>
          </div>
        </div>

        <div className="footer-right">
          <span className="status">
            Status :<span className="status-active"> Active Now</span>
          </span>
        </div>
      </div>
    </div>
  );
}